<template>
  <v-card>
    <v-row no-gutters>
      <v-col>
        <v-card-title class="pb-0">
          <h1 class="headline font-weight-medium mb-2">
            {{ header }}
          </h1>
          <v-spacer />
          <ActionsModalWindow
            v-if="modal"
            :id="id"
            component-name="Manager"
            @close="$emit('close')"
          />
        </v-card-title>
        <v-card-text class="py-0">
          <v-row>
            <v-col cols="6" class="pb-0">
              <CustomTextField
                v-model="title"
                label="Найменування*"
                :error-messages="$v.title.$error ? errors.TITLE : []"
                :hide-details="false"
                @input="$v.title.$touch()"
              />
            </v-col>

            <v-col cols="6" class="pb-0">
              <DecimalEditor
                v-model="salesPlan"
                label="План продаж"
                :required="true"
                :error-messages="$v.salesPlan.$error ? errors.SALES_PLAN : []"
                :hide-details="false"
                @input="$v.salesPlan.$touch()"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6" class="mt-n4">
              <CustomTextField
                v-model="email"
                label="Email"
                @input="isChanged = true"
              />
            </v-col>
          </v-row>
          <ManagerClients v-model="clients" @setClients="setClients" />
        </v-card-text>

        <v-card-actions v-if="!modal">
          <PrimaryBtn
            :has-warnings="$v.$invalid"
            :loading="loading"
            @click="save"
          />
          <v-btn @click="$router.go(-1)">
            Відмінити
          </v-btn>
        </v-card-actions>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import ManagerClients from "./ManagerClients.vue";
import DecimalEditor from "../../../components/DecimalEditor.vue";
import * as managerApi from "../../../backend/managersApi.js";
import PrimaryBtn from "@/components/PrimaryBtn.vue";
import { ERRORS } from "@/helpers";
import { required, minValue } from "vuelidate/lib/validators";

export default {
  components: {
    ManagerClients,
    DecimalEditor,
    PrimaryBtn,
    ActionsModalWindow() {
      return import("@/components/ActionsModalWindow.vue");
    },
  },
  props: ["id", "modal"],
  data: () => ({
    title: "",
    isChanged: false,
    loading: false,
    clients: [],
    salesPlan: 0,
    email: "",
  }),

  validations: {
    title: {
      required,
    },
    salesPlan: {
      minValue: minValue(0),
    },
  },

  computed: {
    isNew() {
      return +this.id ? false : true;
    },
    header() {
      if (this.modal || !this.isNew) {
        return "Менеджер";
      }
      return "Створення менеджера";
    },
    errors() {
      return {
        TITLE: [ERRORS.REQUIRED],
        SALES_PLAN: [ERRORS.REQUIRED],
      };
    },
  },
  async created() {
    if (+this.id) {
      const manager = await managerApi.getManager(this.id);
      this.title = manager.title;
      this.salesPlan = manager.salesPlan;
      this.clients = manager.clients;
      this.email = manager.email;
    }
  },
  methods: {
    async save() {
      this.$v.$touch();

      if (this.$v.$invalid) {
        return;
      }

      this.loading = true;
      const manager = {
        title: this.title,
        salesPlan: this.salesPlan,
        clientIds: this.clients.map(({ id }) => id),
        email: this.email || null,
      };

      try {
        if (!this.isNew) {
          await managerApi.updateManager(this.id, manager);
        } else {
          await managerApi.createManager(manager);
        }
        this.$notifySuccess();
        this.$router.go(-1);
      } catch {
        this.$notifyWarning();
      } finally {
        this.loading = false;
        this.isChanged = false;
      }
    },
    setClients(clients) {
      this.clients = clients;
      this.isChanged = true;
    },
  },
};
</script>
